import React, { useRef, useEffect } from 'react'
import { useRegistrationContext } from '../contexts/registrationContext'
import { strings } from "../assets/resources/translations"
import { uppercase } from '../services/utils/format'
import Radio from '../elements/Radio'


const Ancillary = ({ props, value, handleChange, errors, isDisabled, displayError }) => {
	let { name, options, information, link } = props
	const prevRef = useRef()
	const { price: { addSpecification, removeSpecification } } = useRegistrationContext()

	const getOption = (value) => {
		if (options) {
			for (let o of options) {
				if (o.value === value) {
					return o
				}
			}
		}
		return {}
	}

	useEffect(() => {
		if (value !== undefined) {
			if (prevRef.current) {
				removeSpecification(prevRef.current)
			}
			let option = getOption(value)
			if (option.price !==  0) {

				addSpecification({ ...option, type: "ancillary" })
				prevRef.current = option
			}
		}
	}, [value])

	return (
		<Radio
			name={name}
			label={strings[name] ? uppercase(strings[name]) : uppercase(name)}
			bold={true}
			value={value}
			error={errors[name]}
			onChange={handleChange}
			placeholder={strings.ancillaryPlaceholder} // TODO: make variable
			options={options}
			disabled={isDisabled}
			displayError={displayError}
			information={information}
			link={link}
		/>
	)
}

export default Ancillary